import { render, staticRenderFns } from "./ImageWrapper.vue?vue&type=template&id=82940b9e&scoped=true&"
import script from "./ImageWrapper.vue?vue&type=script&lang=js&"
export * from "./ImageWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82940b9e",
  null
  
)

export default component.exports